import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandLogo from "../../components/BrandLogo";

export default function LegalLayout({ eyebrow, title, version, effective, children }) {
  return (
    <div className="min-h-screen bg-bg">
      <div className="px-6 md:px-12 py-6 border-b border-line flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 w-fit" data-testid="legal-home-link">
          <BrandLogo variant="wordmark" size={28} showLink={false} />
        </Link>
        <Link to="/register" className="text-xs uppercase tracking-widest text-ink-muted hover:text-volt inline-flex items-center gap-2" data-testid="legal-back-link">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to signup
        </Link>
      </div>

      <article className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <div className="label-eyebrow">{eyebrow}</div>
        <h1 className="font-heading text-4xl md:text-5xl uppercase tracking-tighter mt-3" data-testid="legal-title">{title}</h1>
        <div className="mt-3 text-xs uppercase tracking-widest text-ink-muted font-mono">
          Version {version} · Effective {effective}
        </div>

        <div className="mt-10 space-y-8 text-ink-muted leading-relaxed text-sm md:text-base">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-line text-xs text-ink-muted">
          Questions? Email <a className="text-volt" href="mailto:legal@pitchdhq.com">legal@pitchdhq.com</a>.
        </div>
      </article>
    </div>
  );
}

export function Section({ heading, children, testid }) {
  return (
    <section data-testid={testid}>
      <h2 className="font-heading text-xl md:text-2xl uppercase tracking-tight text-white mb-3">{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
